import {CampaignProps} from '@/types/campaign';
import {BriefFieldManagerAttributes} from '@/views/campaigns/brief/brief-field-manager/BriefFieldManager';
import BriefField from '@/views/campaigns/brief/brief-field-manager/brief-field/BriefField';
import DeliverablesBriefItem from '@/views/campaigns/brief/brief-field-manager/brief-field/DeliverablesBriefItem';

class MinimumChildContentSubmissionCount extends BriefField {
  briefFieldManager: BriefFieldManagerAttributes;

  constructor(
    briefFieldManager: BriefFieldManagerAttributes,
    campaignData: CampaignProps,
    key: string,
    value: any
  ) {
    super(briefFieldManager, campaignData, key, value);
    this.briefFieldManager = briefFieldManager;
  }

  set value(value: any) {
    super.value = value;
    if (this.briefFieldManager.fields.deliverablesBriefItem) {
      (
        this.briefFieldManager.fields
          .deliverablesBriefItem as DeliverablesBriefItem
      ).minimumChildContentSubmissionCount = value;
    }
  }

  get value() {
    return super.value;
  }
}

export default MinimumChildContentSubmissionCount;
